import { useState, useEffect } from "react";
import { useToast, Card } from "@chakra-ui/react";
import ListContainer from "components/Wrappers/ListContainer";
import { getDispute } from "api/orders";
import { ExportAction } from "../../components/actions/global/export";
import { Loader } from "components/Loader/loader";
import UpdateDisputeAction from "components/actions/disputes/update-dispute";
import { columns } from "../../variables/disputeData";
import axios from "axios";
import { getCouriers } from "api/couriers";
import { getMerchants } from "api/merchants";
function Dispute() {
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [filterQuery, setFilterQuery] = useState({
    page: 1,
    limit: 25,
    filters: {},
    sortAttribute: "",
    sortDirection: "",
  });

  const [openLoader, setOpenLoader] = useState(false);

  const toast = useToast();

  const [disputesData, setDisputesData] = useState([]);

  const onExport = async () => {
    setOpenLoader(true);
    const exportQuery = { ...filterQuery };
    delete exportQuery?.page;
    delete exportQuery?.limit;
    // TODO: Implement disputes export API
    // const res = await getDisputesExport(exportQuery, toast);
    // openFileInNewTab(res);
    setOpenLoader(false);
  };


  const openFileInNewTab = (response) => {
    const file = new Blob([response.data], { type: "text/csv" });
    const fileURL = URL.createObjectURL(file);
    const a = document.createElement('a');
    a.href = fileURL;
    a.download = 'disputes.csv';
    a.click();
    URL.revokeObjectURL(fileURL);
  };

  async function handleProofImageClick(filename) {
    if (filename && filename !== "-") {
      const token = localStorage.getItem('tokenKey');
      const presignedResponse = await axios.get(
        `${process.env.REACT_APP_ADMIN_API_URL}/dashboard/storage/download-url/${filename}`,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      const { url } = presignedResponse.data.body;
      window.open(url, "_blank");
    }
  }


  const fetchData = async (query) => {
    setIsLoading(true);
    try {
      console.log("Query:", query);
      const res = await getDispute({
        page: query.page, limit: query.limit,
        ...(query?.filters?.status && { status: Array.isArray(query?.filters?.status) ? query?.filters?.status.map(item => item.value).join(",") : query?.filters?.status }),
        ...(query?.filters?.orderNumber && { orderNumber: query?.filters?.orderNumber }),
        ...(query?.filters?.employee && { employee: query.filters.employee }),
        ...(query?.filters?.merchant_name && { merchant: query.filters.merchant_name[0].value }),
        ...(query?.filters?.courier_name && { courier: query.filters.courier_name[0].value }),
      }, toast);

      if (res) {
        const flattenedData = res?.disputes?.map(item => ({
          ...item,
          orderId: item.order?._id || "-",
          orderNumber: item.order?.orderNumber || "-",
          courier_name: item.order?.courier?.name || "-",
          merchant_name: item.merchant?.business_info?.brand || "-",
          status: item.status || "-",
          displayedStatus: item.status === "resolved" ? "Resolved" : item.status === "lost" ? "Lost" : "Pending",
          creation_date: item.creation_date || "-",
          employee: item.employee_email || "-",
          note: item.note || "-",
          resolved_date: item.resolved_date || null, // Keep null instead of "-"
          proof_image: item.proof_image || "-",
        }));

        console.log("Flattened data:", flattenedData[0]);
        setDisputesData(flattenedData);
        setTotalCount(res.count);
      } else {
        console.log("No data in response");
        setDisputesData([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.error("Error fetching disputes:", error);
      setDisputesData([]);
      setTotalCount(0);
    }
    setIsLoading(false);
  };

  // const globalActions = [
  //   {
  //     name: "export",
  //     component: () => <ExportAction onclickExport={onExport} />,
  //     validation: () => true,
  //   },
  // ];

  const getDropDowns = async () => {
    const statusCol = columns.find(
      (col) => col.type === "multi_select" && col.name === "status"
    );
    if (statusCol) {
      statusCol.options = [
        { value: "reviewed", label: "Pending" },
        { value: "resolved", label: "Resolved" },
        { value: "lost", label: "Lost" },
      ];
    }

    const courierCol = columns.find(
      (col) => col.type === "multi_select" && col.name === "courier_name"
    );
    const { couriers } = await getCouriers({ page: 1, limit: 10000 }, toast);
    if (couriers) {
      courierCol.options = couriers.map(item => ({ value: item.name, label: item.name }));
    }
    const merchantCol = columns.find(
      (col) => col.type === "multi_select" && col.name === "merchant_name"
    );
    const {
      merchants
    } = await getMerchants({ page: 1, limit: 10000 }, toast);
    if (merchants) {
      merchantCol.options = merchants.map(item => ({ value: item.brand, label: item.brand }));
    }
  };

  const tableActions = {
    Disputes: [
      {
        name: "update",
        component: (row) => (
          <UpdateDisputeAction row={row} onUpdate={() => fetchData(filterQuery)} />
        ),
        validation: () => true,
      },
    ],
  };

  useEffect(() => {
    fetchData(filterQuery);
    const orderNumberCol = columns.find((col) => col.type === "link" && col.name === 'orderNumber');
    if (orderNumberCol) {
      orderNumberCol.onClickLink = (row) => {
        window.open("/admin/orders/" + row.orderId + "/details", "_blank");
      };
    }
    const proofImageCol = columns.find((col) => col.type === "link" && col.name === 'proof_image');
    if (proofImageCol) {
      proofImageCol.onClickLink = (row) => {
        handleProofImageClick(row.proof_image);
      };
    }
    getDropDowns();
  }, [filterQuery.page]);

  return (
    <>
      <Loader isLoading={openLoader} />

      <Card marginTop={"2rem"} padding={6} borderRadius={40}>
        <ListContainer
          title="Disputes"
          columns={columns}
          data={disputesData}
          filterQuery={filterQuery}
          setFilterQuery={setFilterQuery}
          totalCount={totalCount}
          tableActions={tableActions["Disputes"]}
          hasPagination={true}
          fetchData={fetchData}
          isLoading={isLoading}
        />
      </Card>
    </>
  );
}


export default Dispute








